import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, MenuWrapper } from '../../../component';
import { buildCoordinates } from '../../../shared/utils/map';
import {
  mapPolygonsDrawer,
  searchSocioeconomicDemographicProfile,
} from './redux/socioeconomicDemographic.controller';
import './socioeconomicDemographic.scss';
import nls from './nls/pt-BR.json';

interface SocioeconomicDemographicProps {
  closeModalAction: () => void;
}

export const SocioeconomicDemographic: React.FC<
  SocioeconomicDemographicProps
> = ({ closeModalAction }) => {
  const dispatch = useDispatch();
  const { preference } = useSelector((state: any) => state.layoutState);
  const handleClickSubmit = () => {
    const hasGeometry = dispatch(mapPolygonsDrawer());
    if (!hasGeometry) return;
    dispatch([
      searchSocioeconomicDemographicProfile({
        location: buildCoordinates(),
      }),
      closeModalAction(),
    ]);
  };
  return (
    <MenuWrapper
      title={nls.title}
      market="socioeconomicDemographic"
      submitButtonLabel={nls.apply}
      submitAction={handleClickSubmit}
    ></MenuWrapper>
  );
};
